import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';

import { TagColor, TagSize } from './types';

type TagProps = {
  color: TagColor;
  size: TagSize;
  maxWidth?: number;
};

export const Container = styled.div<TagProps>`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: ${({ theme }) => theme.space[3]}px;
  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth}px;
    `};
  svg {
    cursor: pointer;
  }
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Tag', 'color'))};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Tag', 'size'))};
  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Tag'))};
`;
